import PropTypes from 'prop-types';
import deprecatedProp from '../utils/deprecated_prop';
var tabsI18nPropTypes = {
  scrollStartButton: PropTypes.string,
  scrollLeftButton: deprecatedProp(PropTypes.string, "Deprecated property, please use `scrollStartButton` instead."),
  scrollEndButton: PropTypes.string,
  scrollRightButton: deprecatedProp(PropTypes.string, "Deprecated property, please use `scrollEndButton` instead.")
};
var tabPropTypes = {
  content: PropTypes.node,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.string.isRequired
};
export var tabsPropTypes = {
  appearance: PropTypes.oneOf(['dropShadow', 'outlined']),
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  i18n: PropTypes.shape(tabsI18nPropTypes),
  keepMounted: PropTypes.bool,
  mode: PropTypes.oneOf(['contained', 'extended']),
  onChangeTab: PropTypes.func,
  selectedTabId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tabs: PropTypes.arrayOf(PropTypes.shape(tabPropTypes).isRequired).isRequired,
  type: PropTypes.oneOf(['attached', 'online'])
};